module.exports = __webpack_public_path__ + "static/media/moon.56bd23e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/moon.png
// module id = 734
// module chunks = 0